<template lang="html">
  <div>
    <b-modal modal-class="modal-whatsapp" ref="modal-whatsapp" hide-footer centered title="">
      <div class="box-service">
        <p class="mb-2 text-center">
          <img class="icon" src="public/images/pages/services/icon-3.png">
        </p>
        <h5 class="title">Compra por WhatsApp</h5>
        <p>
          Hules Becerra siempre de la mano con la tecnología te permite hacer pedidos por WhatsApp. Mándamos un mensaje y especifícanos lo que necesitas. Nuestro personal esta listo para ayudarte.
        </p>

        <br />
        <h5 class="text-center subtitle">Envíanos un mensaje por WhatsApp</h5>

        <div class="row mt-2">
          <div class="col-6 col-btn">
            <a class="t-150 btn-whatsApp" target="_blank" href="https://wa.me/5213317283818"><i class="fa-brands fa-whatsapp"></i> Opción 1</a>
          </div>
          <div class="col-6 col-btn">
            <a class="t-150 btn-whatsApp" target="_blank" href="https://wa.me/5213317283112"><i class="fa-brands fa-whatsapp"></i> Opción 2</a>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- WhatsApp -->
    <a class="t-150 ic-whatsapp" @click="$refs['modal-whatsapp'].show();"><i class="fab fa-whatsapp"></i></a>
		<!--  -->
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },

  mounted() {
  }
}
</script>
